<template>
    <div id="demo-basic-card">
        <div id="dashboard-analytics" class="margin-top">
            <div class="vx-row">
                <div class="vx-col md:w-7/12 w-full mt-2 p-0">
                    <div class="vx-card p-6 mt-4">
                        <div class="component w-full pb-4 border-bottom-color">
                            <div class="vx-row">
                                <div class="vx-col md:w-1/2 w-full">
                                    <div class="w-full">
                                        <span class="font-medium text-title-invoice">HOÁ ĐƠN SỐ </span>
                                        <span class="font-medium">#{{ invoice.code }}</span>
                                    </div>
                                    <div class="w-full mt-2" v-if="!invoice.status">
                                        <span class="badge-invoice font-medium" :style="{background: 'rgba(241, 43, 44, 0.12)', color: '#F12B2C'}">CHƯA THANH TOÁN</span>
                                    </div>
                                    <div class="w-full mt-2" v-if="invoice.status">
                                        <span class="badge-invoice font-medium" :style="{background: 'rgba(40, 199, 111, 0.12)', color: '#28C76F'}">ĐÃ THANH TOÁN</span>
                                    </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full text-right">
                                    <div class="component w-full">
                                        <span class="font-medium text-title-invoice">Ngày tạo hoá đơn: </span>
                                        <span class="font-medium">{{ invoice.createdDate }}</span>
                                    </div>
                                    <div class="component w-full mt-2">
                                        <span class="font-medium text-title-invoice">Hạn thanh toán: </span>
                                        <span class="font-medium">{{ invoice.expiredDate }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="w-full p-6 mt-6 noted">
                            <div class="vx-row">
                                <div class="vx-col w-full mb-4">
                                    <b>Lưu ý</b>
                                </div>
                                <div class="vx-col w-full">
                                    <div class="component w-full">
                                        <span>Để hệ thống tự kích hoạt ngay trong 1 phút (ngay sau khi InfoCare nhận đủ thanh toán qua ngân hàng
                                        ), quý khách hàng vui lòng thực hiện đủ các bước sau:</span>
                                    </div>
                                    <div class="component w-full">
                                        <span>Ghi <b class="text-danger">HD{{ invoice.code }}</b> vào nội dung thanh toán.</span>
                                    </div>
                                    <div class="component w-full">
                                        <span>Chuyển khoản số tiền là <b class="text-danger">{{ eArabic(invoice.totalPayment) }}đ</b> để hệ thống tự nhận diện kích hoạt ngay.</span>
                                    </div>
                                    <div class="component w-full">
                                        <span>Nếu khách hàng chuyển khoản khác ngân hàng có thể dùng hình thức chuyển khoản nhanh để được kích hoạt ngay. </span>
                                    </div>
                                    <div class="component w-full">
                                        <span>Quý khách nhận được VAT vui lòng gửi yêu cầu <b class="cursor-pointer" @click="$router.push('/user/v2/invoice-info')">tại đây.</b> Hoá đơn sẽ được gửi cho quý khách hàng trong vòng 7 ngày kể từ ngày yêu cầu.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="vx-row mb-4 mt-4">
                            <div class="vx-col md:w-1/2 w-full mt-4">
                                <div class="w-full component">
                                    <b>Nhà cung cấp</b>
                                </div>
                                <div class="w-full component text-suggest" v-for="(info, indexInfo) in supplierInfomations" :key="indexInfo">
                                    <span>{{ info.label }}</span>
                                </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-4">
                                <div class="w-full component">
                                    <b>Thông tin khách hàng</b>
                                </div>
                                <div class="w-full component text-suggest" v-for="(customer, indexcCus) in customerInfomations" :key="indexcCus">
                                    <span>{{ customer.label }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="w-full mt-4 mb-4 bg-boder p-6">
                            <div class="vx-row m-auto p-4">
                                <div class="flex border-bottom-color w-full">
                                    <div class="w-full">
                                        <div class="vx-row ml-0">
                                            <div class="component w-full pb-4">
                                                    <span class="sm:flex header-float m-auto font-medium text-title-invoice">THÔNG TIN THANH TOÁN</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex border-bottom-color w-full mt-4">
                                    <div class="w-full">
                                        <div class="vx-row ml-0">
                                            <div class="component md:w-1/2 w-full">
                                                    <span class="sm:flex header-float m-auto">Gói</span>
                                            </div>
                                            <div class="component md:w-1/2 w-full">
                                                <div class="component w-full">
                                                    <span class="sm:flex header-float font-medium">{{ businessPackage.name }}</span>
                                                </div>
                                                <div class="component w-full">
                                                    <span class="font-regular">{{ invoice.time }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="vx-row ml-0 text-inline mt-4 pb-4">
                                            <div class="component md:w-1/2 w-full">
                                                <span class="sm:flex header-float m-auto ">Giá trị</span>
                                            </div>
                                            <div class="component md:w-1/2 w-full">
                                                <span class="sm:flex header-float font-bold text-primary"> {{ eArabic(invoice.price) }}đ</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex border-bottom-color w-full mt-4">
                                    <div class="w-full">
                                        <div class="vx-row ml-0">
                                            <div class="component md:w-1/2 w-full">
                                                <span class="sm:flex header-float m-auto">VAT @ 10,00%</span>
                                            </div>
                                            <div class="component md:w-1/2 w-full pb-4">
                                                <span class="sm:flex header-float font-bold"> {{ eArabic(invoice.VAT) }} </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex w-full mt-4">
                                    <div class="w-full">
                                        <div class="vx-row ml-0 bg-total" style="height:40px">
                                            <div class="component md:w-1/2 w-full m-auto">
                                                <span class="sm:flex header-float ">Tổng tiền thanh toán</span>
                                            </div>
                                            <div class="component md:w-1/2 w-full m-auto">
                                                <span class="sm:flex header-float font-bold text-success"> {{ eArabic(invoice.totalPayment) }} </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="w-full mt-4 mb-4 bg-boder p-6">
                            <div class="vx-row m-auto p-4">
                                <div class="flex border-bottom-color w-full">
                                    <div class="w-full">
                                        <div class="vx-row ml-0">
                                            <div class="component w-full pb-4">
                                                    <span class="sm:flex header-float m-auto font-medium text-title-invoice">GIAO DỊCH</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex border-bottom-color w-full mt-4">
                                    <div class="w-full">
                                        <div class="vx-row ml-0">
                                            <div class="component md:w-1/2 w-full">
                                                    <span class="sm:flex header-float m-auto">Ngày giao dịch</span>
                                            </div>
                                            <div class="component md:w-1/2 w-full">
                                                <div class="component w-full" v-if="!invoice.status">
                                                    <span class="sm:flex header-float text-danger">Chưa thanh toán</span>
                                                </div>
                                                <div class="component w-full" v-else>
                                                    <span class="sm:flex header-float text-primary">Đã thanh toán</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="vx-row ml-0 text-inline mt-4 pb-4">
                                            <div class="component md:w-1/2 w-full">
                                                <span class="sm:flex header-float m-auto">Cổng thanh toán</span>
                                            </div>
                                            <div class="component md:w-1/2 w-full" v-if="!invoice.status">
                                                <span class="sm:flex header-float text-danger"> Chưa thanh toán</span>
                                            </div>
                                            <div class="component md:w-1/2 w-full" v-else>
                                                <span class="sm:flex header-float text-primary"> Đã thanh toán</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex border-bottom-color w-full mt-4">
                                    <div class="w-full">
                                        <div class="vx-row ml-0">
                                            <div class="component md:w-1/2 w-full">
                                                <span class="sm:flex header-float m-auto">Mã giao dịch</span>
                                            </div>
                                            <div class="component md:w-1/2 w-full pb-4" v-if="!invoice.status">
                                                <span class="sm:flex header-float text-danger"> Chưa thanh toán </span>
                                            </div>
                                            <div class="component md:w-1/2 w-full pb-4" v-else>
                                                <span class="sm:flex header-float text-primary"> Đã thanh toán </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex border-bottom-color w-full mt-4">
                                    <div class="w-full">
                                        <div class="vx-row ml-0">
                                            <div class="component md:w-1/2 w-full">
                                                <span class="sm:flex header-float m-auto">Số tiền</span>
                                            </div>
                                            <div class="component md:w-1/2 w-full pb-4" v-if="!invoice.status">
                                                <span class="sm:flex header-float text-primary"> {{ eArabic(invoice.totalPayment) }}đ </span>
                                            </div>
                                            <div class="component md:w-1/2 w-full pb-4" v-else>
                                                <span class="sm:flex header-float text-primary"> 0đ </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex w-full mt-4">
                                    <div class="w-full">
                                        <div class="vx-row ml-0 bg-total" style="height:40px">
                                            <div class="component md:w-1/2 w-full m-auto">
                                                <span class="sm:flex header-float ">Số dư cần thanh toán</span>
                                            </div>
                                            <div class="component md:w-1/2 w-full m-auto" v-if="!invoice.status">
                                                <span class="sm:flex header-float font-bold text-success"> {{ eArabic(invoice.totalPayment) }} </span>
                                            </div>
                                            <div class="component md:w-1/2 w-full m-auto" v-else>
                                                <span class="sm:flex header-float font-bold text-success"> 0đ </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="vx-col md:w-5/12 w-full mt-6 pr-0">
                    <div class="vx-card bg-package p-6">

                        <div class="flex border-bottom-color w-full">
                            <div class="w-full">
                                <div class="vx-row ml-0">
                                    <div class="component w-full pb-4">
                                        <span class="sm:flex header-float m-auto font-medium ">SỐ TIỀN CẦN THANH TOÁN</span>
                                    </div>
                                    <div class="component w-full mb-4">
                                        <span class="sm:flex header-float m-auto font-medium total-payment">{{ eArabic(invoice.totalPayment) }}đ</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="flex w-full mt-4">
                            <div class="w-full">
                                <div class="vx-row ml-0">
                                    <div class="component w-full">
                                        <span class="sm:flex header-float m-auto">THÔNG TIN CHUYỂN KHOẢN</span>
                                    </div>
                                </div>
                                <div class="vx-row ml-0 mt-4" v-for="(bank, indexBank) in bankInfomations" :key="indexBank">
                                    <div class="component w-full">
                                        <span class="font-medium">{{ bank.label }}</span>
                                    </div>
                                    <div class="component w-full">
                                        <span class="font-regular">Số tài khoản: {{ bank.stk }}</span>
                                    </div>
                                    <div class="component w-full">
                                        <span class="font-regular">Chi nhánh: {{ bank.branch }}</span>
                                    </div>
                                    <div class="component w-full mb-4">
                                        <span class="font-regular">Chủ tải khoản: {{ bank.accountHolder }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-full mt-4 text-center">
                            <span class="font-medium">Cần sự trợ giúp? </span>
                            <span class="font-medium text-primary cursor-pointer">Liên hệ với chúng tôi để được trợ giúp</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
export default {
    components:{
        
    },
    data(){
        return {
            checkedPaid: true,
            supplierInfomations: [
                {label: 'Công ty TNHH DeepBlue'},
                {label: '12-345678-123'},
                {label: 'Tầng 8, toà HL, ngõ 82 Duy Tân , quận Cầu Giấy, Thành phố Hà Nội'},
                {label: 'Hotline: 024 31234567'},
                {label: 'Email: support@deepblue.vn'},
                {label: 'Đường dây nóng khiếu nại dịch vụ: 0123 456 789'},
                {label: 'Mã số thuế: 12-345678-123'}
            ],
            customerInfomations:[
                {label: ''},
                {label: ''},
                {label: '12-34567-123'},
                {label: ''}
            ],
            bankInfomations: [
                {label: 'Ngân hàng TMCP Ngoại Thương Việt Nam (Vietcombank)', stk: '123 456 7890', branch: 'Thành Công - PGD: Mỹ Đình', accountHolder: 'Công ty TNHH Deepblue'},
                {label: 'Ngân hàng TMCP Ngoại Thương Việt Nam (Vietcombank)', stk: '123 456 7890', branch: 'Thành Công - PGD: Mỹ Đình', accountHolder: 'Công ty TNHH Deepblue'},
                {label: 'Ngân hàng TMCP Ngoại Thương Việt Nam (Vietcombank)', stk: '123 456 7890', branch: 'Thành Công - PGD: Mỹ Đình', accountHolder: 'Công ty TNHH Deepblue'}
            ],
            invoice: {
                code: null,
                createdDate: null,
                expiredDate: null,
                totalPayment: null,
                status: null,
                time: null,
                price: null,
                VAT: null,
                days: null,
                businessPackageId: null
            },
            businessPackage: {}
        }
    },
    methods:{
        getInfomation: function(){
            let dataLocal = localStorage.getItem('userInfo');
            const userInfo = JSON.parse(dataLocal);
            this.customerInfomations[0].label= userInfo.fullName;
            this.customerInfomations[1].label= userInfo.organization.organizationName;
            this.customerInfomations[3].label= userInfo.fullAddress;
        },
        getInvoice: function(){
            const payload = {
                pageSize: 10,
                pageNumber: 0,
            }
            this.$business.post('user-package/get-all-invoice', payload).then((response) => {
                this.getBusinessPackage();
                this.invoice = response.data.content[0];
                this.invoice.createdDate = moment(this.invoice.createdDate).format('DD/MM/YYYY');
                this.invoice.expiredDate = moment(this.invoice.expiredDate).format('DD/MM/YYYY');
                this.invoice.VAT = this.invoice.totalPayment*0.1
                this.invoice.price = this.invoice.totalPayment - this.invoice.VAT;
                
                this.countDateRange(this.invoice.createdDate, this.invoice.expiredDate);
                if (this.invoice.days <= 30) this.invoice.time = "1 tháng";
                if (30 < this.invoice.days <= 90) this.invoice.time = "3 tháng";
                if (90 < this.invoice.days <= 365) this.invoice.time = "12 tháng";
            })
        },
        getBusinessPackage: function(){
            this.$business.get('business-package/all').then((res) => {
                let result = res.data;
                result = result.map(el => {
                    if (el.name.includes('Gói khởi động')) el.name = "Starter - Gói khởi động";
                    if (el.name.includes('Gói cơ bản')) el.name = "Basic - Gói cơ bản";
                    if (el.name.includes('Gói nâng cao')) el.name = "Plus - Gói nâng cao";
                    if (el.name.includes('Gói chuyên nghiệp')) el.name = "Pro - Gói chuyên nghiệp";
                    if (el.name.includes('Gói cao cấp')) el.name = "Premium - Gói cao cấp";
                    return {
                        name: el.name,
                        price: el.price,
                        id: el.id,
                        bg: null
                    }
                })
                this.businessPackage = result.find(el => el.id == this.invoice.businessPackageId);
            })
        },
        countDateRange: function(fromDate, toDate) {
            const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
            const firstDate = new Date(fromDate);
            const secondDate = new Date(toDate);
            const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
            this.invoice.days = diffDays;
        },
        eArabic: function(x) {
            return x.toLocaleString("de-DE");
        },
        initScreen(){
            this.getInfomation();
            this.getInvoice();
        }
    },
    created(){
        this.initScreen();
    }
}
</script>
<style scoped>
.font-label {
    font-size: 12px;
}
.bg-package {
    background: #2f80ec;
    color: white;
}
.text-title-invoice {
    color: #B9B9C3;
}
.text-discount {
    color: #28C76F;
    font-size: 12px;
}
.text-content {
    font-size: 12px;
    color: #B9B9C3;
}
.border-bottom-color {
    border-bottom: 1px solid #D8D6DE;
    /* height: 35px; */
}
.text-suggest {
    color: #5E5873;
}
.margin-top {
    margin-top: -34px;
}
.noted {
    background: rgb(47, 128, 237, .12); 
    color:#2F80ED;
    border: 1px solid #2F80ED;
    border-radius: 5px;
}
.bg-boder {
    border: 1px solid #EBE9F1;
    border-radius: 5px;
}
.bg-total {
    background: #F8F8F8;
}
.badge-invoice {
    padding: .3rem .5rem;
    text-align: center;
    border-radius: .358rem;
}
.total-payment {
    font-size: 24px;
}
</style>